module.exports = __webpack_public_path__ + "static/media/porsche.19f8735f.png";